import * as yup from 'yup';

export const commonChargeOnCompanyMappingValidation: { [x: string]: any; } = {
    chargeOnCompanyCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createChargeOnCompanyMappingValidation: { [x: string]: any; } = {
    ...commonChargeOnCompanyMappingValidation,
};

export const createChargeOnCompanyMappingValidationSchema = yup.object().shape(createChargeOnCompanyMappingValidation);

